var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"frame"},[_c('BreadCrumb'),_c('Banner'),_c('Nav'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('p',[_c('img',{attrs:{"src":"https://www.sclsnk.com/sclsnk_file/mskin/picture/process.jpg","width":"100%"}})])])
}]

export { render, staticRenderFns }